import { Link, Redirect } from "react-router-dom";

import { useUser } from "@/hooks/useUser";
import { INTERNAL_ROUTES, ROUTES } from "@/routes_new";
import Container from "@components/Container";
import Rhythm from "@components/Rhythm";
import Typography from "@components/Typography";

const InternalRoot = () => {
  const { data: userData, isLoading } = useUser();

  if (isLoading) return null;

  const isStaffUser = userData?.ok ? userData.data.is_staff : false;
  if (!isStaffUser) return <Redirect to={ROUTES.APP_HOME} />;

  return (
    <Container>
      <Rhythm>
        <Typography variant="h1">Nya internal-rooten</Typography>
        <Link to={INTERNAL_ROUTES.CHANNEL_LIST}>Kanallistan</Link>
      </Rhythm>
    </Container>
  );
};

export default InternalRoot;
